import React from 'react';

function Enterprise() {
  return (
    <div className="page-container">
      <div className="hero">
        <div className="container">
          <h1>Enterprise Evidence Infrastructure</h1>
          <p>
            For organizations that can't afford evidence integrity failures.
            Law firms, insurance companies, and corporate legal departments.
          </p>
        </div>
      </div>

      <div className="section">
        <div className="section-title">
          <h2>What We Remove</h2>
          <p>Entire categories of risk, not just individual problems</p>
        </div>

        <div className="grid-2">
          <div className="feature-card">
            <h3>Compliance Drag Reduction</h3>
            <p>
              Automated evidence verification reduces manual review time by 80%.
              Less time documenting chain of custody. More time on substantive work.
            </p>
            <div className="benefit-stat mt-4">
              <span className="stat-number">80%</span>
              <span className="stat-label">Time Saved</span>
            </div>
          </div>

          <div className="feature-card">
            <h3>Evidentiary Defensibility</h3>
            <p>
              Cryptographic proof withstands adversarial scrutiny. Every piece of
              evidence has unbreakable verification. No gaps for opposing counsel to exploit.
            </p>
            <div className="benefit-stat mt-4">
              <span className="stat-number">100%</span>
              <span className="stat-label">Admissibility Rate</span>
            </div>
          </div>

          <div className="feature-card">
            <h3>Risk Category Removal</h3>
            <p>
              Eliminate entire classes of evidentiary risks. Sleep better knowing
              evidence integrity is mathematically guaranteed.
            </p>
            <div className="benefit-stat mt-4">
              <span className="stat-number">Zero</span>
              <span className="stat-label">Alterations Possible</span>
            </div>
          </div>
        </div>
      </div>

      <div className="section bg-gray-50">
        <div className="section-title">
          <h2>Enterprise Features</h2>
        </div>

        <div className="grid-3">
          <div className="card">
            <h3>Unlimited Storage</h3>
            <p>Store and verify unlimited evidence files. No per-file fees.</p>
          </div>
          <div className="card">
            <h3>Custom Compliance Reports</h3>
            <p>Generate reports tailored to your jurisdiction and requirements.</p>
          </div>
          <div className="card">
            <h3>Priority Verification</h3>
            <p>Instant verification processing for time-sensitive cases.</p>
          </div>
          <div className="card">
            <h3>SSO Integration</h3>
            <p>Integrate with your existing authentication infrastructure.</p>
          </div>
        </div>
      </div>

      <div className="section">
        <div className="section-title">
          <h2>Get Started Today</h2>
          <p>Choose the plan that fits your organization's needs</p>
        </div>

        <div className="cta-buttons" style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap', marginBottom: '2rem' }}>
          <a
            href="https://enterprise.evidencer.io/pricing"
            className="btn btn-primary btn-large"
            rel="noopener noreferrer"
          >
            View Pricing & Plans →
          </a>
          <a
            href="https://enterprise.evidencer.io/signup"
            className="btn btn-primary btn-large"
            rel="noopener noreferrer"
          >
            Sign Up Now →
          </a>
        </div>

        <div className="cta mt-8">
          <h3>Need a Custom Solution?</h3>
          <p>
            Schedule a consultation to discuss your evidence infrastructure needs.
          </p>
          <a href="mailto:enterprise@evidencer.io" className="btn btn-secondary btn-large">
            Contact Enterprise Sales →
          </a>
        </div>
      </div>
    </div>
  );
}

export default Enterprise;
